import React from 'react'
import { DataTool } from '../../DataTool'
import type { DataToolProps } from '../../DataTool/Context'
import { fieldsConfig as fieldsConfigCore } from '../constants'

export const Toolbox = ({ fieldsConfig = fieldsConfigCore, ...rest }: Partial<DataToolProps>) => {
  return (
    <DataTool
      components={{
        sort: () => null,
      }}
      {...{ fieldsConfig, ...rest }}
    />
  )
}
